export const DPAT_PETITION_TYPE = "DPAT";

export function buildDistrictPetitionTableId(year, districtId) {
  return `${year}petition${districtId}`;
}

export function buildCommitteePetitionTableId(year, districtId) {
  return `${year}petitioncommittee${districtId}`;
}

export function normalizePetitionUserRole(role) {
  return String(role || "").replace(/\s+/g, "_").toUpperCase();
}

export function stripPetitionHtml(html) {
  return String(html || "")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();
}

export function formatPetitionDate(date) {
  if (!date) return "—";
  if (Array.isArray(date)) return date.filter((x) => x != null).join("/");
  return String(date);
}

export function getPetitionDecision(committeeResponse) {
  const decision = String(committeeResponse?.dddpData?.petitionDecision || "")
    .trim()
    .toLowerCase();
  if (decision === "accepted" || decision === "rejected") return decision;
  return null;
}

export function isDecisionOnlyCommitteeResponse(committeeResponse) {
  if (!committeeResponse) return false;
  if (committeeResponse?.dddpData?.committeeResponseSubmitted) return false;
  return Boolean(getPetitionDecision(committeeResponse));
}

export function isAcceptedPetition(committeeResponse) {
  return getPetitionDecision(committeeResponse) === "accepted";
}

export function canViewerSeePetitionContent({ isDistrictUser, committeeResponse }) {
  if (isDistrictUser) return true;
  return isAcceptedPetition(committeeResponse);
}

export function isPetitionEligibleAssessmentStatus(status) {
  const st = String(status || "").trim();
  return st === "Completed" || st === "Closed";
}

export function getPetitionStatusMeta(statusKey) {
  switch (statusKey) {
    case "accepted":
      return {
        key: "accepted",
        label: "Accepted",
        badgeClass: "bg-emerald-50 text-emerald-800 border-emerald-200",
        sortOrder: 3,
      };
    case "rejected":
      return {
        key: "rejected",
        label: "Rejected",
        badgeClass: "bg-red-50 text-red-800 border-red-200",
        sortOrder: 4,
      };
    case "pending":
      return {
        key: "pending",
        label: "Pending review",
        badgeClass: "bg-amber-50 text-amber-800 border-amber-200",
        sortOrder: 2,
      };
    case "submitted":
      return {
        key: "submitted",
        label: "Submitted",
        badgeClass: "bg-sky-50 text-sky-800 border-sky-200",
        sortOrder: 2,
      };
    case "none":
      return {
        key: "none",
        label: "No petition",
        badgeClass: "bg-slate-50 text-slate-600 border-slate-200",
        sortOrder: 1,
      };
    default:
      return {
        key: "not_eligible",
        label: "Not eligible",
        badgeClass: "bg-muted text-muted-foreground border-border",
        sortOrder: 0,
      };
  }
}

export function derivePetitionRowStatus({ assessmentStatus, districtPetition, committeeResponse }) {
  if (!isPetitionEligibleAssessmentStatus(assessmentStatus)) {
    return "not_eligible";
  }
  if (!districtPetition || stripPetitionHtml(districtPetition.comments) === "") {
    return "none";
  }
  const decision = getPetitionDecision(committeeResponse);
  if (decision === "accepted") return "accepted";
  if (decision === "rejected") return "rejected";
  return "pending";
}

export function buildPetitionDecisionHtml(decision, notes = "") {
  const intro =
    decision === "accepted"
      ? "<p>The Complaints Resolution Committee has reviewed the district petition and <strong>accepts</strong> the petition.</p>"
      : "<p>The Complaints Resolution Committee has reviewed the district petition and <strong>rejects</strong> the petition.</p>";
  const trimmedNotes = stripPetitionHtml(notes);
  if (!trimmedNotes) return intro;
  return `${intro}<p>${trimmedNotes.replace(/\n/g, "<br/>")}</p>`;
}
